import { useEffect, useRef} from 'react';
import RadioButton from '../../../elements/radiobutton';
import i18n from '../../../../../utils/translations/i18n';
const tierselect_map={};

export const PriceTier = ({ tierPricesData , priceTierObject ,oldPriceTierObject, isShoppingFeed, selectedIndex, setSelectedIndex, mainItem, showCustomQtySlider}) => {
  const { t } = i18n;
  const priceTierClickRef = useRef(null);
  const hasFreeQuantity = tierPricesData.tierObject.some(tier => tier.freeQuantity);
  const renderTableHeader = (isStrikeOutPricing) => {
    if (isStrikeOutPricing) {
      return (
        <>
          <span>{t('product_details.original_price')}</span>
          <span>{t('product_details.new_price')}</span>
        </>
      );
    } else {
      return <span>{t('product_details.unit_price')}</span>;
    }
  }
  const renderFirstColumn = (tierData, index) => {
    if(!(selectedIndex in tierselect_map) &&
        index === selectedIndex &&
        showCustomQtySlider &&
        (tierData.quantity !== mainItem.quantity)
    ) {
        tierselect_map[selectedIndex]=1;
    }
    return <RadioButton id={tierData.quantity} label={tierData.quantity} isSelected={index === selectedIndex} onChange={() => { }} />;
  }

  // Make new moq as default qantity in edit qantity popup when isBelowMOQ is true
  useEffect(()=>{
    if(mainItem.isBelowMOQ) {
      setSelectedIndex(0);
    }
  },[mainItem]);

  const renderUnitPrice = (tierData, index, tierPricesData, isShoppingFeed) => {
    if (tierPricesData.isStrikeOutPricing) {
      if (isShoppingFeed === "true") { 
        return (<>
          <span className="line-through">{oldPriceTierObject[index].incTaxUnitPriceWithCurrency}</span>
          <span>{tierData.incTaxUnitPriceWithCurrency}</span></>);
      } else {
        return (
          <>
            {oldPriceTierObject[index] && <span className="line-through">{oldPriceTierObject[index].unitPrice}</span>}
            <span className="new-unit-price">{tierData.unitPrice}</span>
          </>
        );
      }
    } else if (isShoppingFeed === "true") {
      return <span>{tierData.incTaxUnitPriceWithCurrency}</span>;
    } else {
      return <span>{tierData.unitPrice}</span>
    }
  }

  const renderSubtotal = (tierData, isShoppingFeed) => {
    if (isShoppingFeed === 'true') {
      return <span>{tierData.incTaxValueWithCurrency}</span>
    } else {
      return <span>{tierData.subtotal}</span>
    }
  }

  const handlePriceTierClick = (e: React.MouseEvent<HTMLElement, MouseEvent>, index) => setSelectedIndex(index);
  const pricingTierPart = <>
    <ul id="pricing-tier-table-selection" className="table-units pricing-tier-table-selection">
      <li className="table-units__item headerRow">
        <span>{t('product_details.quantity')}</span>
        {renderTableHeader(tierPricesData.isStrikeOutPricing)}
        <span>{t('order_summary.subtotal')}</span>
        {hasFreeQuantity && <span className="colorStyle">{t('product_details.extra_free')}</span>}
      </li>

      {priceTierObject?.map((tierData, index: number) => {
        return (
          <li className="table-units__item cursor-pointer" key={tierData.quantity} ref={priceTierClickRef} onClick={(e) => handlePriceTierClick(e, index)} >
            <span>
              {renderFirstColumn(tierData, index)}
              {index === 0 && <div className="price-tier-recommended-msg">{t('product_details.recommended')}</div>}
              {(index === priceTierObject?.length - 1) && <div className="price-tier-best-value-msg"> {t('product_details.best_value')} </div>}
            </span>
            {renderUnitPrice(tierData, index, tierPricesData, isShoppingFeed)}
            {renderSubtotal(tierData, isShoppingFeed)}
            {hasFreeQuantity && <span className='colorStyle'>+{tierData.freeQuantity}</span>}
          </li>
        );
      })}
    </ul>
  </>;

  return (
    <>
      {pricingTierPart}
      {priceTierObject?.length === 0 && <div className="highlight"> {t('product_details.no_tier_price_avl')}</div>}
      <div className="min-saving-percentage-container">
        <span>{t('product_details.min_saving_percentage1')}</span>
        <span className="min-saving-percentage-value"></span>
        <span>{t('product_details.min_saving_percentage2')}</span>
      </div>
    </>
  );
}

